import React from 'react';
import { Link } from 'react-router-dom';

const OUTLETS = [
  { name: 'PTI', url: 'https://theprint.in/india/apollo-hospitals-opens-sports-injuries-centre-in-hyderabad/2925920/' },
  { name: 'Deccan Chronicle', url: 'https://www.deccanchronicle.com' },
  { name: 'Telangana Today', url: 'https://telanganatoday.com/apollo-hospitals-launches-advanced-sports-injuries-centre-in-hyderabad' },
  { name: 'The Hans India', url: 'https://www.thehansindia.com' },
  { name: 'Apollo Hospitals', url: 'https://www.apollohospitals.com' },
];

export const PressStrip = () => (
  <section className="bg-white border-y border-slate-200 py-6" data-testid="press-strip">
    <div className="container mx-auto px-4">
      <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <span className="text-xs font-semibold tracking-widest uppercase text-gray-600 whitespace-nowrap">
          As Seen In
        </span>
        <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
          {OUTLETS.map((o) => (
            <a
              key={o.name}
              href={o.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-base md:text-lg font-serif font-semibold text-gray-500 hover:text-cyan-700 transition-colors"
              data-testid={`press-logo-${o.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {o.name}
            </a>
          ))}
        </div>
        <Link
          to="/in-the-news"
          className="text-sm font-medium text-cyan-700 hover:text-cyan-900 md:ml-auto whitespace-nowrap"
          data-testid="press-strip-viewall"
        >
          View coverage →
        </Link>
      </div>
    </div>
  </section>
);

export default PressStrip;
